import { gql } from '@apollo/client';

export const START_REPORTING_PERIOD = gql`
  mutation startReportingPeriod($id: ID!) {
    start: startReportingPeriod(id: $id) {
      periodId
      itemType
      monitoringFormId
      periodNumber
      workspaceFormId
      reportId
      recordId
    }
  }
`;
